<template>
    <!-- desktop e mobile os campos sao diferentes, por isso as 2 tables -->
    <div class="t-display">
        <!-- desktop -->
        <b-table
            class="t-desktop mt-4"
            v-if="!mobile"
            hover
            :items="itemsList"
            :fields="fields"
        >
            <template
                v-for="field in fields"
                v-slot:[`cell(${field.key})`]="{ value, item }"
            >
                <b-input
                    v-if="itemRow && itemRow.id === item.id"
                    v-model="itemRow[field.key]"
                    :key="field.key"
                    :type="field.type || 'text'"
                    :number="field.isNumber"
                ></b-input>

                <template v-else-if="field.checkbox">
                    <b-form-checkbox
                        v-model="selected"
                        :value="item.content"
                        :key="field.key"
                        @change="manageMedia(item, itemsList.indexOf(item))"
                    />
                </template>

                <!-- now there is a condition for fields that have `image: true` -->
                <template v-else-if="field.image">
                    <base-image
                        ref="baseImage"
                        :source="item.content"
                        :key="field.key"
                        :externalImage="false"
                        :customClass="'t-img rounded-sm'"
                        :fitIn="'65x65'"
                    />
                </template>

                <template v-else-if="field.name">
                    <div class="row" :key="field.key">
                        <div class="flex">
                            <span>{{showName(value)}}</span>
                            <span class="font-italic font-12" v-if="inGallery(item.content)"> Adicionada</span>
                        </div>

                        <button @click="copyUrl(item)" class="d-none position-absolute btn btn-copy">
                            Copiar Link
                        </button>
                    </div>
                </template>

                <template v-else>{{ value }}</template>
            </template>
        </b-table>


        <!-- mobile -->
        <b-table
            v-else
            class="t-mobile mt-4"
            :items="itemsList"
            :fields="mobileFields"
            responsive
        >
            <template
                v-for="field in mobileFields"
                v-slot:[`cell(${field.key})`]="{ value, item }"
            >
                <b-input
                    v-if="itemRow && itemRow.id === item.id"
                    v-model="itemRow[field.key]"
                    :key="field.key"
                    :type="field.type || 'text'"
                    :number="field.isNumber"
                ></b-input>

                <template v-else-if="field.checkbox">
                    <b-form-checkbox
                        size="sm"
                        v-model="selected"
                        :value="item.content"
                        :key="field.key"
                        @change="manageMedia(item, itemsList.indexOf(item))"
                    />
                </template>

                <!-- now there is a condition for fields that have `image: true` -->
                <template v-else-if="field.image">
                    <base-image
                        :source="item.content"
                        :key="field.key"
                        :externalImage="false"
                        :customClass="'t-img rounded-sm'"
                        :fitIn="'35x35'"
                    />
                </template>

                <template v-else-if="field.actions">
                    <b-dropdown
                        :key="field.actions"
                        id="t-mobile-actions"
                        class="t-mobile-actions--dropdown"
                        dropleft
                        no-caret
                    >
                        <template #button-content>
                            <span>...</span>
                        </template>

                        <b-dropdown-item
                            @click="copyUrl(item)"
                        >
                            Copiar Link
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

                <template v-else>{{ value }}</template>
            </template>
        </b-table>
    </div>
</template>

<script>
import BaseImage from "./BaseImage.vue";
export default {
    name: "TableDisplay",
    components: { BaseImage },
    props: {
        items: {
            type: Array,
            required: true
        },
        isSelected: {
            type: Function,
            required: false
        },
        manageMedia: {
            type: Function,
            required: false
        },
        selectedMedias: {
            type: Array,
            required: false
        },
        selectedMediasLength: {
            type: Number,
            required: false
        },
        deleteMedia: {
            type: Function,
            required: true
        },
        inGallery: {
            type: Function,
            required: false,
        },
    },
    data() {
        return {
            mobile: window.innerWidth < 576,
            selected:
                this.selectedMediasLength > 0
                    ? this.selectedMedias.map(item => item.url)
                    : [],
            itemRow: {},
            fields: [
                { key: "checkbox", label: "", checkbox: true },
                { key: "img", label: "", image: true },
                { key: "name", label: "Nome", name: true },
                { key: "dt_envio", label: "Data de envio" },
                { key: "dt_criacao", label: "Data de criação" },
                // { key: "size", label: "Tamanho" },
            ],
            mobileFields: [
                { key: "checkbox", label: "", checkbox: true },
                { key: "img", label: "", image: true },
                { key: "name", label: "Nome" },
                { key: "actions", label: "Açōes", actions: true }
            ]
        };
    },
    methods: {
        showName(name) {
            if (name.length > 40) {
                return name.substring(0, 40) + '...';
            }
            return name;
        },
        copyUrl(post) {
            if (post.type === 'image') {
                this.$emit('copyImageLink', this.$refs.baseImage.find(img => img.source === post.content));
            } else {
                this.$emit('copyVideoLink', post);
            }
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },
    },
    computed: {
        itemsList() {
            return this.items.map(item => ({
                ...item,
                dt_envio: item.datetime,
                dt_criacao: item.datetime,
                size: item.size ? this.formatBytes(item.size, 2) : '-'
            }));
        }
    },
    watch: {
        selectedMediasLength(value) {
            if (value == 0) {
                this.selected = [];
            } else {
                this.selected = this.selectedMedias.map(item => item.url);
            }
        }
    }
};
</script>

<style>
.table thead th {
    font-family: "Open Sans", sans-serif;
    font-weight: bold;
    font-size: 0.55rem;
}

.table td {
    font-family: "Open Sans", sans-serif;
    font-size: 0.55rem;
}

/* campo checkbox */
.t-desktop td[aria-colindex="1"] {
    display: flex;
    justify-content: center;
    height: 100%;
}

/* alguns ajustes no botao de acoes, sobrescrevendo os estilos do bs4 */

.t-mobile-actions--dropdown button {
    color: #3f3f3f;
    background-color: transparent !important;
    border-radius: 0;
}

.t-mobile .btn-secondary:focus {
    color: #000000 !important;
}

.btn:hover,
.btn:not(:disabled):not(.disabled).active,
.btn:not(:disabled):not(.disabled):active,
.show > .btn.dropdown-toggle {
    color: #000000 !important;
}

/* tratamento das imagens dos td */

.t-desktop .base-image {
    max-width: 65px;
    max-height: 65px;
}

.t-desktop tr {
    position: relative;
}

.t-mobile .base-image {
    max-width: 35px;
    max-height: 35px;
}

tr:hover td[aria-colindex="3"] button {
    display: block!important;
}

.t-display .btn-copy {
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    font-size: 0.75rem;
    background-color: #E3E3E3;
    color: #000000;
    transition: 500ms opacity ease-out;
    bottom: 15%;
}

.t-display .btn-copy:hover {
    transition: 500ms opacity ease-in;
    color: var(--main-color)!important;
}


@media screen and (min-width: 576px) {
    .table thead th {
        font-size: 0.75rem;
    }

    .table td {
        font-size: 0.75rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/TableDisplay.vue